// extracted by mini-css-extract-plugin
export var active = "_5n-a";
export var activeIndicator = "_5n-9";
export var disabled = "_5n-b";
export var fullWidth = "_5n-2";
export var lg = "_5n-7";
export var md = "_5n-6";
export var redoButtonTabGroup = "_5n-0";
export var sm = "_5n-5";
export var tabButton = "_5n-4";
export var tabButtonsContainer = "_5n-1";
export var themeDestructive = "_5n-d";
export var themeNormal = "_5n-c";
export var themeSuccess = "_5n-e";
export var xl = "_5n-8";
export var xs = "_5n-3";